// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3SbL4","title":"AfterBackImages_title__3auxl","images":"AfterBackImages_images__3Whcp"};